//                         __
//   ___ _   _____  ____  / /______
//  / _ \ | / / _ \/ __ \/ __/ ___/
// /  __/ |/ /  __/ / / / /_(__  )
// \___/|___/\___/_/ /_/\__/____/

/* global */

// import Splitting from 'splitting';
// import { setupObserverGravityForms } from './observer-setup';
// import { splitInner } from './splitting-setup';

const setupEvents = () => {
  console.log('{ setupEvents }');

  const siteMenu = document.querySelector('.js-site-menu');

  // ----------------------------------------------------------------------------
  //
  // Doc events
  //
  // ----------------------------------------------------------------------------
  $(document).off('click');
  $(document)
    // ----------------------------------------------------------------------------
    // Site Nav - Open
    // ----------------------------------------------------------------------------
    .on('click', '.js-nav-site-open', () => {
      // reveal main nav
      $(siteMenu).addClass('open');

      // console.log( 'siteMenu.querySelectorAll(.splitting): %o', siteMenu.querySelectorAll('.splitting') );

      const items = siteMenu.querySelectorAll('.splitting');

      // loop through each item
      $.each(items, function(i, el) {
        // delay trigger
        let intervalID = setTimeout(() => {
          // reveal text
          $(el).addClass('show');

          clearTimeout(intervalID);
        }, 500 + 150 * i);
      });
    })

    // ----------------------------------------------------------------------------
    // Site Nav - Close
    // ----------------------------------------------------------------------------
    .on('click', '.js-nav-site-close', () => {
      // hide main nav
      $(siteMenu).removeClass('open');

      // delay trigger
      // let intervalID = setTimeout( function () {

      // reset splitting text
      $(siteMenu)
        .find('.splitting')
        .removeClass('show');

      // clearTimeout( intervalID );

      // }, 500 );
    })

    // ----------------------------------------------------------------------------
    // Generic elements that need active state
    // ----------------------------------------------------------------------------
    .on('mouseover', '.js-link-active', function() {
      $(this)
        .addClass('active')
        .find('.splitting')
        .addClass('show');
    })
    .on('mouseout', '.js-link-active', function() {
      $(this)
        .removeClass('active')
        .find('.splitting')
        .removeClass('show');
    })

    // ----------------------------------------------------------------------------
    // Gravity Forms fields
    // ----------------------------------------------------------------------------
    .on('click', '.gfield', function() {
      $(this)
        // hide label text
        .find('.gfield_label')
        .removeClass('show')
        // focus form field
        .find('.ginput_container >')
        .focus();
    })

    // ----------------------------------------------------------------------------
    // Gravity Forms field on blur
    // ----------------------------------------------------------------------------
    .on('blur', '.ginput_container >', function() {
      const t = $(this);

      if ('' === t.val()) {
        // show label if nothing entered into field
        t.parent()
          .parent('.gfield')
          .find('.gfield_label')
          .addClass('show');
      }
    })

    // ----------------------------------------------------------------------------
    // Gravity Forms field on blur
    // ----------------------------------------------------------------------------
    .on('focus', '.ginput_container >', function() {
      const t = $(this);

      if ('' === t.val()) {
        // show label if nothing entered into field
        t.parent()
          .parent('.gfield')
          .find('.gfield_label')
          .removeClass('show');
      }
    })

    // ----------------------------------------------------------------------------
    // Card Link
    // ----------------------------------------------------------------------------
    .on('mouseover', '.js-card--link__link', function() {
      // reveal copy
      $(this)
        .find('.card--link__copy')
        .addClass('show');
    })
    .on('mouseout', '.js-card--link__link', function() {
      // hide copy
      $(this)
        .find('.card--link__copy')
        .removeClass('show');
    })

    // ----------------------------------------------------------------------------
    // Show map button
    // ----------------------------------------------------------------------------
    .on('click', '.js-link-map', function(e) {
      e.preventDefault();

      const wrapper = $(this)
        .parent()
        .parent()
        .siblings('.location__bg');

      if (!wrapper.hasClass('show')) {
        // add 'show' class to map & bg image wrapper to fire CSS animations
        wrapper.addClass('show');
      }
    });

  // .on('gform_post_render', (event, form_id, current_page) => {
  //   console.log('event: %o', event);
  //   console.log('form_id: %o', form_id);
  //   console.log('current_page: %o', current_page);
  // apply splitting
  // Splitting({
  //   target: '.gfield [data-splitting]',
  //   by: 'lines'
  // });
  // splitInner($('.gfield_label .word'));
  // fire observer checking code for reveal animation
  // setupObserverGravityForms();
  // });
};

export { setupEvents };



// WEBPACK FOOTER //
// ./scripts/modules/events.js